var level1Task1 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
<block type="text_print" id="{c~87;0MC1w:nV2I#Qg0" x="37" y="62">
<value name="TEXT">
<block type="logic_compare" id="eaD]Ql:}[EV+=md^^m]n">
<field name="OP">EQ</field>
<value name="A">
<block type="math_arithmetic" id="X(ug+cM%fpPCRdT9]RZ">
<field name="OP">MINUS</field>
<value name="A">
<shadow type="math_number" id="otOH5oiBT$XL}^GQ-st*">
<field name="NUM">11</field>
</shadow>
</value>
<value name="B">
<shadow type="math_number" id="je%:i63}mxqbf{i3}]4">
<field name="NUM">2</field>
</shadow>
</value>
</block>
</value>
<value name="B">
<block type="math_number" id="b$u7,.s,TvNy~hi2l0+M">
<field name="NUM">5</field>
</block>
</value>
</block>
</value>
<next>
<block type="text_print" id=";bVwc4~m3nZ~[hH~IkKX">
<value name="TEXT">
<block type="logic_compare" id="yCh7w/2IQV*w-c[zhRy:">
<field name="OP">NEQ</field>
<value name="A">
<block type="math_arithmetic" id=":c8Di?~Nwo4{5)J{Ahun">
<field name="OP">MULTIPLY</field>
<value name="A">
<shadow type="math_number" id="u[TL#5McWG_Z/RvB9k#W">
<field name="NUM">5</field>
</shadow>
</value>
<value name="B">
<shadow type="math_number" id="JA6dY0k4H8~u{vp]1wyd">
<field name="NUM">4</field>
</shadow>
</value>
</block>
</value>
<value name="B">
<block type="math_number" id="j|ORuU=Lb3aH;B[CPaun">
<field name="NUM">20</field>
</block>
</value>
</block>
</value>
<next>
<block type="text_print" id="q;0BpqVYtNfuKB4-1d(">
<value name="TEXT">
<block type="logic_compare" id="k@f$2ov([_5ZW/F%kK(E">
<field name="OP">LT</field>
<value name="A">
<block type="math_arithmetic" id="_#4A05E670cjD(vhMf1d">
<field name="OP">ADD</field>
<value name="A">
<shadow type="math_number" id="OXxTn%2B?uZ~qb-W35hO">
<field name="NUM">6</field>
</shadow>
</value>
<value name="B">
<shadow type="math_number" id="5k|i08-CRPgd+_ZhOub">
<field name="NUM">5</field>
</shadow>
</value>
</block>
</value>
<value name="B">
<block type="math_number" id="P1by#b:^M,+y3TVXp(7.">
<field name="NUM">7</field>
</block>
</value>
</block>
</value>
<next>
<block type="text_print" id="9ltmj4W{e{e_j=Gysy8g">
<value name="TEXT">
<block type="logic_compare" id="2J:n4(16j*QRE[Unz">
<field name="OP">GT</field>
<value name="A">
<block type="math_arithmetic" id="kU%:(LVho6|Mw~9k+gj">
<field name="OP">DIVIDE</field>
<value name="A">
<shadow type="math_number" id="ffiIJtfOAAdG93:I|zXW">
<field name="NUM">18</field>
</shadow>
</value>
<value name="B">
<shadow type="math_number" id="{V@#FhujY/W%Hs$-,@S[">
<field name="NUM">3</field>
</shadow>
</value>
</block>
</value>
<value name="B">
<block type="math_number" id="**5*@4jUpIz]HxLV:9GI">
<field name="NUM">9</field>
</block>
</value>
</block>
</value>
</block>
</next>
</block>
</next>
</block>
</next>
</block>
</xml>
`
export default level1Task1 